import { render, staticRenderFns } from "./PACK.vue?vue&type=template&id=70a1b5be&scoped=true&"
import script from "./PACK.vue?vue&type=script&lang=js&"
export * from "./PACK.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70a1b5be",
  null
  
)

export default component.exports
import {QHeader,QToolbar,QToolbarTitle,QCard,QCardSection,QSpace,QSelect,QIcon,QInput,QBtn,QBtnDropdown,QPopupProxy,QDate,QSeparator,QTable,QToggle,QTr,QTh,QTd,QChip,QTooltip,QInnerLoading,ClosePopup} from 'quasar'
component.options.components = Object.assign({QHeader,QToolbar,QToolbarTitle,QCard,QCardSection,QSpace,QSelect,QIcon,QInput,QBtn,QBtnDropdown,QPopupProxy,QDate,QSeparator,QTable,QToggle,QTr,QTh,QTd,QChip,QTooltip,QInnerLoading}, component.options.components || {})
component.options.directives = Object.assign({ClosePopup}, component.options.directives || {})
